import React, {Fragment, useEffect, useRef, useState} from "react";
import moment from "moment";
import {useMutation} from "react-query";
import {useHistory, useLocation, useParams} from "react-router-dom";
import {ErrorMessage, Field, FieldArray, Formik,} from "formik";
import Partials from "../partials";
import {useDispatch, useSelector} from 'react-redux';
import UTILS from "../../utils";
import {getTeacherPlayList} from "../../api/playlist";
import {Popover, Transition} from "@headlessui/react";
import {FiSearch, FiTrash2} from "react-icons/fi";
import {TbClipboardCheck} from 'react-icons/tb'
import Fields from "../formFields";
import {FaChevronDown} from "react-icons/fa";
import {BsPlus} from "react-icons/bs";
import {addItemsToClass, getClassPlan, removeClassPlanItem} from "../../api/classPlan";
import {getAssignmentList} from "../../api/assignment";
import BlockCustomDialog from "../blocks/BlockCustomDialog";
import {setUpdateClassPlan} from "../../store/classPlan";
import {getClassDetailsById} from "../../utils/reactQueries";
import { IoMdArrowBack } from "react-icons/io";


const validateTotalTime = (values, duration) => {
  const totalTime = values.classPlan.reduce(
    (sum, item) => sum + Number(item.timeToCover || 0),
    0
  );
  return totalTime <= duration;
};
const defaultValue = [
  {
    title: "",
    timeToCover: 0,
    assignment: { label: "Select Options", value: "Select Options" },
    question: "",
    content: { label: "Select Options", value: "Select Options" },
    playlistTitle: "",
    teacher_id: "",
    checkGroupSelection: "",
  },
];

const questionListDummy = [
  { value: "question-1", label: "question-1" },
  { value: "question-2", label: "question-2" },
  { value: "question-3", label: "question-3" },
];
const validateTimeToCover = (value) => {
  if (!value) return "Required";
  if (String(value).includes('.') || value % 1 !== 0) {
    return "Decimal values are not allowed";
  }
  return undefined;
};
export default function PageCrateClassPlan() {
  let arrayHelpersRef = useRef(null).current;

  /** get the class created data from the redux*/
  const classPlanData = useSelector((state) => state.classPlan.classPlan);
  const dispatch = useDispatch();
  const [isLoading, setLoading] = useState(false);
  const [removeLoader, setRemoveLoader] = useState(false);
  const [playlistData, setPlaylists] = useState([]);
  const [initialValues, _setInitialValues] = useState({
    classPlan: classPlanData?.length > 0 ? classPlanData : defaultValue,
  });

  const history = useHistory();
  const params = useParams();
  const classId = params.classId;
  const ClassPlanID = params?.ClassPanID;
  const [duration, setDuration] = useState(0); //set the class duration
  const [assignmentList, setAssignmentList] = useState([]);
  const [questionList, setQuestionList] = useState([]);
  const location = useLocation();
  const splitData = location?.pathname?.split("/");
  const newUrl = splitData.slice(0, 3).join("/");
  const [isOpen, setOpen] = useState(false);
  const [loader, setLoader] = useState(false);
  const [removeCurrentRow, setRemoveCurrentRow] = useState({
    arrayHelpers: {},
    classPlan: [],
    index: 0,
    plan: {},
  });

  /** Effect use to check the localstorage class-plan ID and arrived class-plan ID same or not */
  useEffect(() => {
    const localStorageClassPlanID = localStorage.getItem("classPlanID");
    const splitURL = location.pathname.split("/");
    const classPlanID = splitURL[splitURL.length - 1];
    if (localStorageClassPlanID !== classPlanID) {
      history.replace("/teacher/home");
    }
  }, []);

  const {
    status,
    data: classData,
    error: classError,
    isFetching,
  } = getClassDetailsById(classId);
  const classDetails = classData?.data;

  /** get the current playlist data */
  const fetchListData = () => {
    getTeacherPlayList()
      .then((res) => {
        const playListData = res?.data.body;
        if (playListData?.length > 0) {
          setPlaylists(playListData);
        }
      })
      .catch((error) => {
        console.log("Error ", error);
      });
  };

  /** fet the class and playlist data when page render first time*/
  useEffect(() => {
    fetchListData();
  }, []);

  /** get the assignment list*/
  useEffect(() => {
    getAssignmentList()
      .then((res) => {
        const data = res.data.body;
        if (data?.length > 0) {
          setAssignmentList(data);
        } else {
          setAssignmentList([]);
        }
      })
      .catch((error) => {
        console.log("Error getting the assignment list", error);
      });
    return () => {
      setAssignmentList([]);
    };
  }, []);

  /** get the question list*/
  useEffect(() => {
    setQuestionList(questionListDummy);
  }, []);

  /** add the unique id in initial values*/
  useEffect(() => {
    const durationMinutes = Number(classDetails?.duration_seconds) / 60; // get the total duration of the class in minutes
    setDuration(durationMinutes);
    const data = initialValues.classPlan.map((item) => {
      return {
        ...item,
        classDuration: durationMinutes,
        content: { label: "Select Options", value: "Select Options" },
        playlistTitle: "",
        assignmentTitle: "",
        questionTitle: "",
        assignment: { label: "Select Options", value: "Select Options" },
        question: { label: "Select Options", value: "Select Options" },
        checkGroupSelection: "",
      };
    });
    if (data?.length > 0) {
      _setInitialValues({ classPlan: data });
    }
  }, [classDetails]);

  const makeLabelFormat = (value) => {
    return value ? value : "Select Options";
  };
  const valueFormat = (value) => {
    return value ? value : "Select Options";
  };

  /** get the class plan data already exist*/
  const getClassPlanData = () => {
    const durationMinutes = Number(classDetails?.duration_seconds) / 60;
    getClassPlan(ClassPlanID)
      .then((res) => {
        const classPlanDetails = res?.data?.body;
        /** get the total duration of the class in minutes*/
        const classPlanItems = res.data.body?.class_plan_items;
        if (classPlanItems?.length > 0) {
          const newData = classPlanItems?.map((item) => {
            return {
              id: item?.id,
              verified: false,
              timeToCover: item?.duration_in_minutes,
              classDuration: durationMinutes,
              teacher_id: classPlanDetails?.teacher_id,
              content: {
                label: makeLabelFormat(item?.playList?.title),
                value: valueFormat(item?.playList?.id),
              },
              assignment: {
                label: makeLabelFormat(item?.assignment?.title),
                value: valueFormat(item?.assignment?.id),
              },
              question: {
                label: makeLabelFormat(item?.question?.title),
                value: valueFormat(item?.question?.id),
              },
              playlistTitle: "",
              assignmentTitle: "",
              questionTitle: "",
              title: item?.title,
            };
          });
          if (newData?.length > 0) {
            _setInitialValues({ classPlan: newData });
          }
        }
      })
      .catch((error) => console.log("Error", error));
  };

  useEffect(() => {
    getClassPlanData();
  }, []);

  /** redirect to create-virtual class if class id is not get*/
  useEffect(() => {
    if (!classId) {
      history.replace("/create-virtual-class");
    }
  });

  /** redirect the assignment page*/
  const addAssignment = () => {
    history.push({
      pathname: `${newUrl}/adding-assignment`,
      state: { classPlanID: ClassPlanID },
    });
  };

  /** redirect the question page*/
  const addQuestions = () => {
    history.push({
      pathname: `${newUrl}/adding-question`,
      state: { classPlanID: ClassPlanID },
    });
  };

  /** use to search the exact playlist*/
  const searchPlayList = (value) => {
    const filterList = playlistData
      ?.filter((item) => item.title.toLowerCase().includes(value.toLowerCase()))
      .map((item) => {
        return {
          label: item?.title,
          value: item?.id,
        };
      });

    if (filterList?.length > 0) {
      return filterList;
    } else {
      return [];
    }
  };

  /** use to search the exact Assignment list*/
  const searchAssignmentList = (value) => {
    if (assignmentList?.length > 0) {
      const filterList = assignmentList
        ?.filter((item) =>
          item?.title.toLowerCase().includes(value?.toLowerCase())
        )
        .map((item) => {
          return {
            label: item?.title,
            value: item.id,
          };
        });
      if (filterList?.length > 0) {
        return filterList;
      } else {
        return [];
      }
    } else {
      return [];
    }
  };

  /** use to search the exact playlist*/
  const searchQuestionList = (value) => {
    if (questionList?.length > 0) {
      const filterList = questionList
        ?.filter((item) =>
          item?.value.toLowerCase().includes(value?.toLowerCase())
        )
        .map((item) => {
          return {
            label: item?.label,
            value: item.value,
          };
        });
      if (filterList?.length > 0) {
        return filterList;
      } else {
        return [];
      }
    } else {
      return [];
    }
  };

  /** go to content page*/
  const goToAddingContentPage = () => {
    history.push({
      pathname: `${newUrl}/adding-content`,
      state: { classPlanID: ClassPlanID },
    });
  };

  /** go to student edit page add page*/
  const goToStudentPage = () => {
    const URL = `${newUrl}/add-students`;
    history.push(URL);
  };

  /** add / update class items in  batch*/
  const { mutate: modifyClassItems } = useMutation(addItemsToClass, {
    onSuccess: (data, variables) => {
      getClassPlanData();
      setLoading(false);
      dispatch(setUpdateClassPlan(true));
      alert("class Plan Items Add Successfully..!");
      setLoader(false);
      goToStudentPage();
    },
    onError: (err) => {
      console.log(err);
      alert("Something Went wrong...");
      setLoading(false);
      setLoader(false);
    },
  });

  /** Add / update class items individually*/
  const { mutate: modifyIndividuallyItems } = useMutation(addItemsToClass, {
    onSuccess: (data, variables) => {
      getClassPlanData();
      setLoading(false);
      dispatch(setUpdateClassPlan(true));
      alert("class Plan Items Add Successfully..!");
      setLoader(false);
    },
    onError: (err) => {
      console.log(err);
      alert("Something Went wrong...");
      setLoading(false);
      setLoader(false);
    },
  });

  /** calculate the total time cover*/
  const calculateTotalTimeCover = (classPlanData) => {
    const sumOfTimeCover = classPlanData.reduce(
      (previousValue, currentValue) =>
        previousValue + Number(currentValue?.timeToCover),
      0
    );
    return sumOfTimeCover;
  };

  /** submit the form to create the class*/
  const handleSubmit = (values, { setSubmitting }) => {
    const classPlan = values.classPlan;
    let sum = calculateTotalTimeCover(classPlan);

    if (sum <= 0 || sum > duration) {
      alert("Time To Cover is not Match");
    } else {
      try {
        let defaultValue = "Select Options";
        setLoading(true);
        const classPlanData = values.classPlan;
        const addItemsObj = {};

        const itemsPayload = classPlanData?.map((item) => {
          let payload = {
            title: item?.title,
            duration_in_minutes: item?.timeToCover,
            description: "",
          };

          if (item?.content?.value !== defaultValue) {
            payload = {
              ...payload,
              playList: {
                id: item?.content?.value,
              },
            };
          }
          if (item?.assignment?.value !== defaultValue) {
            payload = {
              ...payload,
              assignment: {
                id: item?.assignment?.value,
              },
            };
          }
          if (item?.id) {
            return {
              ...payload,
              id: item.id,
            };
          } else {
            return {
              ...payload,
            };
          }
        });

        addItemsObj.addPlanItems = itemsPayload;
        if (itemsPayload) {
          modifyClassItems({
            classPlanID: ClassPlanID,
            classPlanItems: addItemsObj,
          });
        }
      } catch (error) {
        console.log("Error", error);
      } finally {
        setLoading(false);
      }
    }
  };

  const modifySingleRow = (rowData, values) => {
    const classPlan = values.classPlan;
    let sumOfTime = calculateTotalTimeCover(classPlan);

    const defaultContentValue = "Select Options";
    if (rowData?.title === "") {
      alert("Title is Required");
    } else if (sumOfTime <= 0 || sumOfTime > duration) {
      alert("Time To Cover is not Match");
    } else {
      if (
        rowData?.content?.label === defaultContentValue &&
        rowData?.assignment?.label === defaultContentValue &&
        rowData?.question?.label === defaultContentValue
      ) {
        alert("Please select any one from assignment/content/question");
      } else {
        try {
          setLoader(true);
          let tempArr = [];
          let addItemsObj = {};
          const defaultValue = "Select Options";
          let payload = {
            title: rowData?.title,
            duration_in_minutes: rowData?.timeToCover,
            description: "",
          };
          if (rowData?.id) {
            payload = {
              ...payload,
              id: rowData?.id,
            };
          }
          if (rowData?.content?.value !== defaultValue) {
            payload = {
              ...payload,
              playList: {
                id: rowData?.content?.value,
              },
            };
          }
          if (rowData?.assignment?.value !== defaultValue) {
            payload = {
              ...payload,
              assignment: {
                id: rowData?.assignment?.value,
              },
            };
          }
          tempArr.push(payload);
          addItemsObj.addPlanItems = tempArr;

          if (addItemsObj) {
            modifyIndividuallyItems({
              classPlanID: ClassPlanID,
              classPlanItems: addItemsObj,
            });
          }
        } finally {
          setLoader(false);
        }
      }
    }
  };
  

  //this function used to scroll the bottom for display the newly added class plan list
  const handleListScroll = (listId) => {
    setTimeout(() => {
      const element = document.getElementById(`class-plan-list-${listId}`);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }, 100);
  };

  /** add the row to form*/
  const addRow = (arrayHelpers) => {
    const studentList = arrayHelpers?.form?.values?.classPlan?.length + 1;

    arrayHelpers.push({
      verified: false,
      timeToCover: 0,
      classDuration: duration,
      content: { label: "Select Options", value: "Select Options" },
      assignment: { label: "Select Options", value: "Select Options" },
      question: { label: "Select Options", value: "Select Options" },
      playlistTitle: "",
      assignmentTitle: "",
      questionTitle: "",
      title: "",
      checkGroupSelection: "",
    });
    handleListScroll(studentList);
  };

  /** remove the row frm the form*/
  const getConfirmationToDelete = () => {
    const rowContentId = removeCurrentRow?.plan?.id;
    let arrayHelpers = removeCurrentRow?.arrayHelpers;
    let index = removeCurrentRow?.index;
    let classPlan = removeCurrentRow?.classPlan;

    if (rowContentId) {
      setRemoveLoader(true);
      removeClassPlanItem(rowContentId)
        .then((res) => {
          arrayHelpers.remove(index);
          getClassPlanData();
          alert("Delete the content Successfully...!");
          if (classPlan?.length === 1) {
            addRow(arrayHelpers);
          }
        })
        .catch((error) => {
          console.log("Error to delete the class plan content ");
        })
        .finally(() => {
          setRemoveLoader(false);
          setOpen(false);
        });
    } else {
      if (classPlan?.length === 1) {
        addRow(arrayHelpers);
      }
      arrayHelpers.remove(index);
      setOpen(false);
    }
  };

  const removeRow = (arrayHelpers, index, classPlan, plan) => {
    setRemoveCurrentRow({
      plan,
      index,
      classPlan,
      arrayHelpers,
    });
  };
  const handleGoBack = () => {
    history.push(`/teacher/${classId}/create-class-plan`);
  };
  return (
    <div className="page PageCreateClassPlan">
      <div className="container" id="contentWrapperBox">
        <div className="h-screen pt-20 flex flex-col relative pb-24">
          <div>
            <h3 className="flex justify-center items-center gap-2 text-center font-extrabold text-2xl md:text-4xl font-['Poppins-Bold']">
              <div className="block lg:hidden">
                <IoMdArrowBack
                  size={20}
                  className="cursor-pointer"
                  onClick={handleGoBack}
                />
              </div>
              <div className="hidden lg:block">
                <IoMdArrowBack
                  size={40}
                  className="cursor-pointer"
                   onClick={handleGoBack}
                />
              </div>
              Create your class plan
            </h3>
            <ul
              className={
                "flex flex-wrap md:flex-row gap-4 md:gap-8 mb-6 md:mb-14 text-sm md:text-xl items-center justify-center my-2 list-none"
              }
            >
              <li className="flex justify-center items-center gap-2">
                <p>
                  <i className="icon icon-book-open"></i>{" "}
                  {classDetails?.subject?.title}
                </p>
              </li>
              <li className="flex justify-center items-center gap-2">
                <i className="icon icon-menu"></i>
                <p className="break-all">{classDetails?.title}</p>
              </li>
              <li className="flex justify-center items-center gap-2">
                <i className="icon icon-calendar"></i>
                <p>
                  {moment(
                    // Convert to milliseconds if timestamp is small (Unix seconds)
                    classDetails?.createdOn > 1e12 ? 
                      classDetails.createdOn : 
                      (classDetails?.createdOn || 0) * 1000
                  ).format("MM.DD.YYYY")}
                </p>
              </li>
              <li className="flex justify-center items-center gap-2">
                <i className="icon icon-clock"></i>
                <p>
                  {moment.unix(classDetails?.start_time).format("HH:mmA")}-
                  {moment
                    .unix(
                      classDetails?.start_time + classDetails?.duration_seconds
                    )
                    .format("HH:mmA")}
                </p>
              </li>
            </ul>
          </div>
          <Formik
            initialValues={initialValues}
            enableReinitialize
            validationSchema={UTILS.forms.CreateClassPlanSchema}
            onSubmit={handleSubmit}
          >
            {({
              values,
              handleSubmit,
              isSubmitting,
              errors,
              setValues,
              setFieldValue,
              touched,
            }) => (
              <form
                onSubmit={handleSubmit}
                className="flex flex-col flex-1 overflow-y-auto pb-4"
                style={{ minHeight: "50vh" }}
              >
                <div className="flex-auto">
                  <FieldArray
                    name="classPlan"
                    render={(arrayHelpers) => {
                      const classPlan = values.classPlan;
                      arrayHelpersRef = arrayHelpers;
                      return (
                        <>
                          <div className="hidden lg:flex classCreateTitleWrapper flex flex-col lg:flex-row  gap-x-5 m-3 ">
                            <div className="srNo">
                              <span>Sr.No</span>
                            </div>
                            <div
                              className="flex flex-auto lg:grow-[3.5] lg:shrink-[5] flex-col pl-[18px]"
                              // style={{paddingLeft: '18px'}}
                            >
                              <span className=" mb-3">Topic</span>
                            </div>
                            <div
                              className="flex flex-auto lg:w-[2.125rem] flex-col pl-[18px]"
                              // style={{paddingLeft: '35px'}}
                            >
                              <span className="">Time To Cover</span>
                            </div>
                            <div
                              className="flex flex-auto lg:w-[2.125rem] flex-col lg:flex-row pl-[18px]"
                              // style={{paddingLeft: '35px'}}
                            >
                              <span className=" mb-3 ">Assignment</span>
                            </div>
                            <div
                              className="flex flex-auto lg:w-[3.125rem] flex-col lg:flex-row pl-[20px]"
                              // style={{paddingLeft: '18px'}}
                            >
                              <span className="mb-3">Content</span>
                            </div>
                            <div
                              className="flex flex-auto lg:w-[3.125rem] flex-col lg:flex-row mr-[105px]"
                              // style={{marginRight: '52px'}}
                            >
                              <span className="mb-3 w-full">Question</span>
                            </div>
                          </div>

                          <div className="block BlockClassPlan max-h-96">
                            {classPlan.map((plan, index) => (
                              <div key={index} className="flex items-start">
                            
                                {index === classPlan.length - 1 && (
                                  <div className="mr-2 mt-8">
                                    <button
                                      type="button"
                                      onClick={() => addRow(arrayHelpers)}
                                      className="text-black hover:text-gray-600"  
                                    >
                                      <i className="icon icon-plus-circle text-2xl"></i>
                                    </button>
                                  </div>
                                )}
                              
                              
                              <div className="flex-1">
                                <Transition
                                  as={Fragment}
                                  show={index > -1}
                                  key={"add-students-to-class" + index}
                                  enter="transform transition duration-[400ms]"
                                  enterFrom="opacity-0 scale-90"
                                  enterTo="opacity-100 scale-100"
                                >
                                  <div
                                    id={`class-plan-list-${index + 1}`}
                                    className="classCreateWrapper flex flex-col lg:flex-row gap-x-9 m-3"
                                  >
                                    <span className="lg:hidden md:block mb-3 text-black text-lg">
                                      Sr.No
                                    </span>
                                    <div className="flex flex-auto srNo">
                                      <div className="block hover:hidden">
                                        {index + 1}
                                      </div>
                                    </div>
                                    <div className="flex flex-auto lg:grow-[5] lg:shrink-[5] flex-col ">
                                      <span className="lg:hidden md:block mb-3 mt-3 text-black text-lg">
                                        Topic
                                      </span>
                                      <Field
                                        type={"text"}
                                        name={`classPlan.${index}.title`}
                                        placeholder="Title"
                                        component={Fields.FieldInput}
                                        wrapperClasses=" fieldHeight w-full"
                                      />
                                      <ErrorMessage
                                        name={`classPlan.${index}.title`}
                                      >
                                        {(msg) => (
                                          <div
                                            className={"text-red-500 text-xs"}
                                          >
                                            {msg}
                                          </div>
                                        )}
                                      </ErrorMessage>
                                    </div>
                                    <div className="flex flex-auto lg:w-[5.125rem] flex-col">
                                      <span className="lg:hidden md:block mb-3 text-black text-lg">
                                        Time To Cover
                                      </span>
                                      <Field
                                        type="text"
                                        name={`classPlan.${index}.timeToCover`}
                                        component={Fields.FieldTimeCoverInput}
                                        placeholder="Time to cover"
                                        inputClasses=" time-to-cover-input text-2xl rounded-tl-md rounded-bl-md w-16 "
                                        wrapperClasses=" w-full"
                                        unit="mins"
                                        min={0}
                                        validate={(value) => {
                                          const basicValidation = validateTimeToCover(value);
                                          if (basicValidation) return basicValidation;

                                          const totalTime = values.classPlan.reduce(
                                            (sum, item, idx) => 
                                              sum + Number(idx === index ? value : item.timeToCover || 0),
                                            0
                                          );
                                          if (totalTime > duration) {
                                            return `Total time (${totalTime} mins) exceeds class duration (${duration} mins)`;
                                          }
                                          return undefined;}}
                                        iconUp={
                                          <FaChevronDown className="text-lg rotate-180 cursor-pointer" />
                                        }
                                        iconDown={
                                          <FaChevronDown className="text-lg cursor-pointer" />
                                        }
                                        timeIncrement={() => {
                                        const totalDuration = Number(plan?.classDuration);
                                        const currentVal = Number(classPlan[index].timeToCover) || 0; // ensure number

                                        if (currentVal >= totalDuration) {
                                          setFieldValue(`classPlan.${index}.timeToCover`, totalDuration);
                                        } else {
                                          setFieldValue(`classPlan.${index}.timeToCover`, currentVal + 1);
                                        }
                                      }}

                                      timeDecrement={() => {
                                        const currentVal = Number(classPlan[index].timeToCover) || 0;

                                        if (currentVal <= 0) {
                                          setFieldValue(`classPlan.${index}.timeToCover`, 0);
                                        } else {
                                          setFieldValue(`classPlan.${index}.timeToCover`, currentVal - 1);
                                        }
                                      }}

                                      />
                                      <ErrorMessage
                                        name={`classPlan.${index}.timeToCover`}
                                      >
                                        {(msg) => (
                                          <div
                                            className={
                                              "text-red-500 text-xs mt-5"
                                            }
                                          >
                                            {msg}
                                          </div>
                                        )}
                                      </ErrorMessage>
                                    </div>
                                    <div className="flex flex-auto lg:w-[5.125rem] flex-col">
                                      <span className="lg:hidden md:block mb-3 mt-3 text-black text-lg">
                                        Assignment
                                      </span>
                                      <Popover className="relative shadow bg-white py-3 rounded-md  focus:outline-none rounded-bl-md rounded-br-md h-12">
                                        <div className="selectPlayListBtn text-sm text-gray-400 focus:outline-none border-none mx-2">
                                          <Popover.Button>
                                            <input
                                              name={`classPlan.${index}.assignment`}
                                              value={
                                                classPlan[index].assignment
                                                  ?.label || ""
                                              }
                                              className={`cursor-pointer w-11/12 ${
                                                classPlan[index].assignment
                                                  ?.label !==
                                                  "Select Options" &&
                                                "text-black"
                                              }`}
                                              readOnly
                                            />
                                            <FaChevronDown className="text-lg text-black" />
                                          </Popover.Button>
                                        </div>
                                        <Popover.Panel className="absolute  z-10 w-full shadow  rounded-xl mt-5">
                                          {({ close }) => (
                                            <div className="flex justify-center flex-col w-full bg-white px-2 py-2">
                                              <Field
                                                type="text"
                                                name={`classPlan.${index}.assignmentTitle`}
                                                placeholder="search"
                                                iconBefore={<FiSearch />}
                                                component={Fields.FieldSearch}
                                              />
                                              <div className="searchPlayList flex flex-col border-b border-gray-300 gap-2 pb-2 mt-2  overflow-y-scroll overflow-x-hidden">
                                                {assignmentList?.length > 0 ? (
                                                  searchAssignmentList(
                                                    classPlan[index]
                                                      ?.assignmentTitle
                                                  )?.map(
                                                    (item, playListIndex) => (
                                                      <span
                                                        onClick={() => {
                                                          setFieldValue(
                                                            `classPlan.${index}.assignment`,
                                                            item
                                                          );
                                                          close();
                                                        }}
                                                        key={playListIndex}
                                                        className="text-black text-sm cursor-pointer"
                                                      >
                                                        {item?.label}
                                                      </span>
                                                    )
                                                  )
                                                ) : (
                                                  <span className="text-xs">
                                                    List Not Available
                                                  </span>
                                                )}
                                              </div>
                                              <div
                                                onClick={() => addAssignment()}
                                                className="flex justify-between items-center w-full cursor-pointer"
                                              >
                                                <span className="text-sm text-black">
                                                  Create New
                                                </span>
                                                <BsPlus className="text-xl text-black" />
                                              </div>
                                            </div>
                                          )}
                                        </Popover.Panel>
                                      </Popover>
                                      <ErrorMessage
                                        name={`classPlan.${index}.assignment`}
                                      >
                                        {(msg) => (
                                          <div
                                            className={
                                              "text-red-500 text-xs  mt-8"
                                            }
                                          >
                                            {msg}
                                          </div>
                                        )}
                                      </ErrorMessage>
                                    </div>

                                    <div className="flex flex-auto lg:w-[5.125rem] flex-col lg:flex-row">
                                      <div className="w-full">
                                        <span className="lg:hidden md:block mb-3 mt-3 text-black text-lg">
                                          Content
                                        </span>
                                        <Popover className="relative shadow bg-white py-3 rounded-md  focus:outline-none rounded-bl-md rounded-br-md h-12">
                                          <div className="selectPlayListBtn text-sm text-gray-400 focus:outline-none border-none mx-2">
                                            <Popover.Button>
                                              <input
                                                name={`classPlan.${index}.content`}
                                                value={
                                                  classPlan[index].content
                                                    ?.label || ""
                                                }
                                                className={`cursor-pointer w-11/12 ${
                                                  classPlan[index].content
                                                    ?.label !==
                                                    "Select Options" &&
                                                  "text-black"
                                                }`}
                                                readOnly
                                              />
                                              <FaChevronDown className="text-lg text-black" />
                                            </Popover.Button>
                                          </div>
                                          <Popover.Panel className="absolute  z-10 w-full shadow  rounded-xl mt-5">
                                            {({ close }) => (
                                              <div className="flex justify-center flex-col w-full bg-white px-2 py-2">
                                                <Field
                                                  type="text"
                                                  name={`classPlan.${index}.playlistTitle`}
                                                  placeholder="search"
                                                  iconBefore={<FiSearch />}
                                                  component={Fields.FieldSearch}
                                                />
                                                <div className="searchPlayList flex flex-col border-b border-gray-300 gap-2 pb-2 mt-2  overflow-y-scroll overflow-x-hidden">
                                                  {playlistData?.length > 0 ? (
                                                    searchPlayList(
                                                      classPlan[index]
                                                        .playlistTitle
                                                    )?.map(
                                                      (item, playListIndex) => (
                                                        <span
                                                          onClick={() => {
                                                            setFieldValue(
                                                              `classPlan.${index}.content`,
                                                              item
                                                            );
                                                            close();
                                                          }}
                                                          key={playListIndex}
                                                          className="text-black text-sm cursor-pointer"
                                                        >
                                                          {item?.label}
                                                        </span>
                                                      )
                                                    )
                                                  ) : (
                                                    <span className="text-xs">
                                                      List Not Available
                                                    </span>
                                                  )}
                                                </div>
                                                <div
                                                  onClick={() =>
                                                    goToAddingContentPage()
                                                  }
                                                  className="flex justify-between items-center w-full cursor-pointer"
                                                >
                                                  <span className="text-sm text-black">
                                                    Create Playlist
                                                  </span>
                                                  <BsPlus className="text-xl text-black" />
                                                </div>
                                              </div>
                                            )}
                                          </Popover.Panel>
                                        </Popover>
                                        <ErrorMessage
                                          name={`classPlan.${index}.checkGroupSelection`}
                                        >
                                          {(msg) => (
                                            <div
                                              className={
                                                "text-red-500 text-xs mt-8"
                                              }
                                            >
                                              {msg}
                                            </div>
                                          )}
                                        </ErrorMessage>
                                      </div>
                                    </div>

                                    <div className="flex flex-auto lg:w-[5.125rem] flex-col lg:flex-row">
                                      <div className="w-full">
                                        <span className="lg:hidden md:block mb-3 mt-3 text-black text-lg">
                                          Question
                                        </span>
                                        <Popover className="relative shadow bg-white py-3 rounded-md  focus:outline-none rounded-bl-md rounded-br-md h-12">
                                          <div className="selectPlayListBtn text-sm text-gray-400 focus:outline-none border-none mx-2">
                                            <Popover.Button>
                                              <input
                                                name={`classPlan.${index}.question`}
                                                value={
                                                  classPlan[index].question
                                                    ?.label || ""
                                                }
                                                className={`cursor-pointer w-11/12 ${
                                                  classPlan[index].question
                                                    ?.label !==
                                                    "Select Options" &&
                                                  "text-black"
                                                }`}
                                                readOnly
                                              />
                                              <FaChevronDown className="text-lg text-black" />
                                            </Popover.Button>
                                          </div>
                                          <Popover.Panel className="absolute  z-10 w-full shadow  rounded-xl mt-5">
                                            {({ close }) => (
                                              <div className="flex justify-center flex-col w-full bg-white px-2 py-2">
                                                <Field
                                                  type="text"
                                                  name={`classPlan.${index}.questionTitle`}
                                                  placeholder="search"
                                                  iconBefore={<FiSearch />}
                                                  component={Fields.FieldSearch}
                                                />
                                                <div className="searchPlayList flex flex-col border-b border-gray-300 gap-2 pb-2 mt-2  overflow-y-scroll overflow-x-hidden">
                                                  {questionList?.length > 0 ? (
                                                    searchQuestionList(
                                                      classPlan[index]
                                                        .questionTitle
                                                    )?.map(
                                                      (
                                                        item,
                                                        questionListIndex
                                                      ) => (
                                                        <span
                                                          onClick={() => {
                                                            setFieldValue(
                                                              `classPlan.${index}.question`,
                                                              item
                                                            );
                                                            close();
                                                          }}
                                                          key={
                                                            questionListIndex
                                                          }
                                                          className="text-black text-sm cursor-pointer"
                                                        >
                                                          {item?.label}
                                                        </span>
                                                      )
                                                    )
                                                  ) : (
                                                    <span className="text-xs">
                                                      List Not Available
                                                    </span>
                                                  )}
                                                </div>
                                                <div
                                                  onClick={() => addQuestions()}
                                                  className="flex justify-between items-center w-full cursor-pointer"
                                                >
                                                  <span className="text-sm text-black">
                                                    Add Questions
                                                  </span>
                                                  <BsPlus className="text-xl text-black" />
                                                </div>
                                              </div>
                                            )}
                                          </Popover.Panel>
                                        </Popover>
                                        <ErrorMessage
                                          name={`classPlan.${index}.question`}
                                        >
                                          {(msg) => (
                                            <div
                                              className={
                                                "text-red-500 text-xs mt-8"
                                              }
                                            >
                                              {msg}
                                            </div>
                                          )}
                                        </ErrorMessage>
                                      </div>
                                    </div>
                                    <span className="lg:hidden md:block mb-3 mt-3 text-black text-lg">
                                      Remove
                                    </span>
                                    <div className="flex flex-auto justify-between lg:w-[5.125rem] remove">
                                      <div
                                        className=""
                                        onClick={() => {
                                          removeRow(
                                            arrayHelpers,
                                            index,
                                            classPlan,
                                            plan
                                          );
                                          setOpen(true);
                                        }}
                                      >
                                        <button
                                          type={"button"}
                                          className={"px-1 "}
                                        >
                                          {removeLoader ? (
                                            <Partials.PartialLoading
                                              classes={
                                                "text-zinc-800 -h-10 -w-10"
                                              }
                                            />
                                          ) : (
                                            <FiTrash2 className="text-2xl text-black cursor-pointer " />
                                          )}
                                        </button>
                                      </div>
                                      <div
                                        className=""
                                        onClick={() =>
                                          modifySingleRow(plan, values)
                                        }
                                      >
                                        <button
                                          type={"button"}
                                          className={"px-1 "}
                                        >
                                          {loader ? (
                                            <Partials.PartialLoading
                                              classes={
                                                "text-zinc-800 -h-10 -w-10"
                                              }
                                            />
                                          ) : (
                                            <TbClipboardCheck className="text-2xl text-black cursor-pointer " />
                                          )}
                                        </button>
                                      </div>
                                    </div>
                                    </div>
                                    </Transition>
                                  </div>
                                </div>
                              ))}
                            </div>
                          <div className="mt-4 mb-4 pl-4"> 
                          {/* <button
                            type={"button"}
                            className={"mt-2"}
                            onClick={() => addRow(arrayHelpers)}
                          >
                            <i className="icon icon-plus-circle text-2xl"></i>
                          </button> */}
                          </div>
                        </>
                      );
                    }}
                  />
                </div>
                <div className="fixed bottom-0 left-0 right-0 bg-white py-4 shadow-lg border-t border-gray-200">
                <div className="container mx-auto px-4"> {/* Added mx-auto and px-4 */}
                  <div className="flex justify-center">
                    <button
                      disabled={isLoading}
                      className="bg-black w-full max-w-md hover:bg-slate-600 text-white font-bold py-3 px-4 rounded-lg focus:outline-none focus:shadow-outline"
                      type="submit"
                    >
                      {isLoading && <Partials.PartialLoading />}
                      save and Continue
                    </button>
                  </div>
                </div>
              </div>
              </form>
            )}
          </Formik>
        </div>
      </div>
      <BlockCustomDialog
        targetId="contentWrapperBox"
        open={isOpen}
        onClose={() => setOpen(false)}
        overlayClasses="justify-center items-center backdrop-blur-md"
      >
        <div className="w-96 flex flex-col rounded-full p-4 gap-8">
          <h4 className="text-xl text-center font-medium">
            Are you sure to delete this Record..!
          </h4>
          <div className="flex justify-center items-center">
            <button
              onClick={() => setOpen(false)}
              className="w-30 mx-auto px-10 py-2 text-black font-extrabold font-[Poppins-Bold] rounded-lg border-black border"
            >
              No
            </button>
            <button
              onClick={() => getConfirmationToDelete()}
              className="w-30 mx-auto px-10 py-2 text-white bg-black font-extrabold font-[Poppins-Bold] rounded-lg"
            >
              yes
            </button>
          </div>
        </div>
      </BlockCustomDialog>
    </div>
  );
}